import { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export function DownloadLink(props) {
  const { url, displayName, downloadFilename } = props;
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(false);

  if (!url) return null;

  const defaultFileName = decodeURIComponent(url.split('/')?.at(-1));
  const filename = downloadFilename || defaultFileName;
  const display = displayName || filename;

  const getIcon = () => {
    if (error) return <ErrorOutlineIcon color="error" />;
    if (downloading) return <CircularProgress size={20} />;
    return <DownloadIcon />;
  };

  const handleDownload = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (error) return;

    try {
      setDownloading(true);
      const response = await fetch(`/api/admin/files?url=${url}`);

      if (!response.ok) {
        setError(true);
        return;
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch {
      setError(true);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Button
      variant="text"
      startIcon={getIcon()}
      onClick={handleDownload}
      disabled={downloading || error}
      title={error ? 'Error downloading file' : filename}
      sx={{
        justifyContent: 'flex-start',
        textTransform: 'none',
        minWidth: 0,
        maxWidth: '100%',
        paddingLeft: 0,
        marginLeft: '-4px',
        color: 'inherit',
        '& .MuiButton-startIcon': {
          marginRight: 0.5,
          marginLeft: 0,
        },
        '& .MuiButton-endIcon, & .MuiButton-startIcon': {
          flexShrink: 0,
        },
      }}
    >
      <Box
        sx={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          minWidth: 0,
        }}
      >
        {display}
      </Box>
    </Button>
  );
}
